<template>
  <button
    :disabled="loading"
    :class="[
      'bg-danger-50 border-danger-100 hover:bg-danger-100 text-danger-500 focus:ring-danger-500 flex justify-center rounded-md border px-4 py-2 text-sm font-normal shadow-sm focus:outline-hidden focus:ring-2 focus:ring-offset-2',
      loading ? ['bg-danger-100 hover:bg-danger-100'] : '',
    ]"
    :data-test="'TButtonInlineDangerous-' + dataTestName"
    @click="action"
  >
    <TIcon v-if="loading" name="loader" class="mr-2 h-5 w-5 animate-spin" />
    <span v-if="!loading">
      <slot />
    </span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  loading?: boolean;
  action?: () => void;
  dataTestName?: string;
}>();
</script>
